"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomForm = (function () {
    function CustomForm(customForm) {
        var _this = this;
        this.name = "customForm";
        this.finalise = null;
        this.validate = null;
        this.devFill = null;
        this.previewAutoFill = null;
        this.fields = customForm.fields;
        this.registerImperativeHandlers = function (_a) {
            var validate = _a.validate, finalise = _a.finalise, devFill = _a.devFill, previewAutoFill = _a.previewAutoFill;
            _this.validate = validate;
            _this.finalise = finalise;
            _this.devFill = devFill;
            _this.previewAutoFill = previewAutoFill;
        };
    }
    return CustomForm;
}());
exports.default = CustomForm;
